import getEnvVariable from './getEnvVariable';

export const ENV_PREFIX = 'REACT_APP_' as const;

export const ADMIN_CLIENT_API_ULR = getEnvVariable('ADMIN_CLIENT_API_ULR');

// --- Help Links ---
const ATLASSIAN_BASE = 'https://support-itmlimited.atlassian.net';
const WIKI_SPACE = `${ATLASSIAN_BASE}/wiki/spaces/UH/pages`;

export const HELP_URLS = {
  serviceDesk:  `${ATLASSIAN_BASE}/servicedesk/customer/portals`,
  dictionaries: `${WIKI_SPACE}/1639088139/Dictionaries`,
  templates:    `${WIKI_SPACE}/1639415936/Templates`,
  application:  `${WIKI_SPACE}/1638072338/Application`,
} as const;
